<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '275px' }"
>
    <!--
    0: {Budgetlevelid: 3, Budgetlevel: "CostType"}
1: {Budgetlevelid: 2, Budgetlevel: "Item"}
2: {Budgetlevelid: 1, Budgetlevel: "Employee"}
-->
    <p-header> Add Project Budget </p-header>
    <form [formGroup]="addBudgetFormGroup">
        <p-floatLabel variant="on" class="mb-4 mt-4">
            <p-select fluid
                id="budgetTask"
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="tasks"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="TaskListID"
            ></p-select>
            <label>Task</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <p-select fluid
                id="budgetCostType"
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="costTypes"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="CostType"
            ></p-select>
            <label>Cost Type</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <p-select fluid
                id="budgetServiceItem"
                [disabled]="contract?.Budgetlevelid === 3"
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="serviceItems"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="SIListID"
            ></p-select>
            <label>Item</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <p-select fluid
                #budgetPerson
                id="budgetPerson"
                [disabled]="
                    contract?.Budgetlevelid === 3 ||
                    contract?.Budgetlevelid === 2
                "
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="users"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="PersonListID"
            ></p-select>
            <label>Employee/Consultants</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <p-select fluid
                id="budgetPayrollItem"
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="filteredPayrollItems$ | async"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="PIListID"
                [disabled]="!budgetPerson.value"
            ></p-select>
            <label>Payroll Item</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4" *ngIf="costCenters?.length > 1">
            <p-select fluid
                id="budgetCostCenter"
                [virtualScroll]="true"
                [itemSize]="dropdownItemHeight"
                [autoDisplayFirst]="false"
                [options]="costCenters"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                formControlName="CostCenterID"
            ></p-select>
            <label>Cost Center</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <input
                pInputText
                fluid
                id="budgetDisburseHours"
                class="w-full"
                type="number"
                step="0.01"
                formControlName="DisburseHours"
                (input)="
                    addBudgetFormGroup.controls.DisburseHours.setValue(
                        $any($event.target).value
                    )
                "
            />
            <label for="budgetDisburseHours">Disburse Hours</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-4">
            <input
                pInputText
                fluid
                id="budgetDisburseAmount"
                class="w-full"
                type="number"
                step="0.01"
                formControlName="DisburseAmount"
                (input)="
                    addBudgetFormGroup.controls.DisburseAmount.setValue(
                        $any($event.target).value
                    )
                "
            />
            <label for="budgetDisburseAmount">Disburse $</label>
        </p-floatLabel>
    </form>
    <ng-template #footer >
        <button
            pButton
            type="button"
            label="Cancel"
            icon="pi pi-times"
            (click)="Cancel.next()"
            class="p-button-text p-button-danger"
        ></button>
        <button
            pButton
            type="button"
            label="Save"
            icon="pi pi-check"
            (click)="onSaveClicked()"
            class="p-button-text p-button-success"
            [disabled]="this.addBudgetFormGroup.invalid"
        ></button>
    </ng-template>
</p-dialog>
